import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormGroup,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DatasetListItem } from "../../app/backendTypes";

export default function DatasetsPicker(props: {
  datasets: DatasetListItem[];
  loading: boolean;
  error: string | undefined;
  onChange: (val: DatasetListItem | null) => void;
  initialValue: DatasetListItem | null;
}) {
  const { datasets, loading, error, onChange, initialValue } = props;

  const theme = useTheme();

  return (
    <FormControl fullWidth>
      <FormGroup>
        <Autocomplete
          value={initialValue}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          size="small"
          disabled={loading || Boolean(error)}
          options={datasets}
          getOptionLabel={(dataset) => dataset.id}
          renderOption={(props, dataset) => (
            <Typography {...props}>{dataset.id}</Typography>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              placeholder={
                loading ? "Loading..." : error ? "Error" : "Pick a dataset"
              }
              error={Boolean(error)}
              sx={{
                input: {
                  "&::placeholder": {
                    color: Boolean(error)
                      ? theme.palette.error.main
                      : "text.secondary",
                    opacity: 1,
                  },
                },
              }}
            />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </FormGroup>
    </FormControl>
  );
}
